/**
 * Suppresses console errors, warnings, and logs in production
 * This prevents end users from seeing errors in the browser console
 */
if (process.env.NODE_ENV === 'production' && typeof window !== 'undefined') {
  // Store original console methods
  const originalConsole = {
    error: console.error,
    warn: console.warn,
    log: console.log,
    info: console.info,
    debug: console.debug
  };

  // Override console methods to suppress output in production
  console.error = () => {};
  console.warn = () => {};
  console.log = () => {};
  console.info = () => {};
  console.debug = () => {};

  // Optionally, you can still log to a service in production
  // For now, we're just suppressing all console output
}


